import React from 'react';
import './GIEContainer.css';

export default class GIEContainer extends React.Component<any, any> {
    render() {
        const {children, title, imgUrl} = this.props;
        return (
            <div>
                <div className="title-container">
                    <div className="title-circle-container"></div>
                    <div className="title-image-container">
                        <img src={imgUrl} alt="Fond du header"/>
                    </div>
                    <div className="title-text-container">
                        {title}
                    </div>
                </div>
                {children}
            </div>
        );
    }
}
